<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-3">
              <div>
                <h4 class="card-title">Job #</h4>
                <b-form-input
                  for="text"
                  placeholder="Job #"
                  v-model="searchJobNum"
                  :class="{ 'is-invalid': searchJob_errors.jobNumError }"
                ></b-form-input>
                <div
                  v-if="searchJob_errors.jobNumError"
                  class="invalid-feedback"
                >
                  <span>{{ searchJob_errors.jobNumMessage }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mt-4 mt-lg-0">
                <h4 class="card-title">Customer</h4>
                <v-select
                  id="ddl_customers"
                  :options="customers"
                  label="customer"
                  v-model="searchCustomer"
                ></v-select>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mt-4 mt-lg-0">
                <h4 class="card-title">Start Date</h4>
                <date-picker
                  v-model="searchStartDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mt-4 mt-lg-0">
                <h4 class="card-title">End Date</h4>
                <date-picker
                  v-model="searchEndDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
            </div>
          </div>
          <!-- end row -->
          <div class="row mt-3 float-right">
            <div class="col-3">
              <switches
                text-enabled="Show Completed Jobs"
                text-disabled="Show Completed Jobs"
                v-model="showCompletedJobs"
                type-bold="false"
                color="primary"
              ></switches>
            </div>
            <div class="col-5">
              <switches
                text-enabled="Only Show Jobs with Unapproved Items"
                text-disabled="Only Show Jobs with Unapproved Items"
                v-model="showUnapprovedJobsItems"
                type-bold="false"
                color="primary"
              ></switches>
            </div>
            <div class="col-4 mt-4 mt-lg-0">
              <b-button
                id="btn_search"
                variant="primary"
                v-on:click="searchJobs()"
                >Search</b-button
              >
            </div>
          </div>
          <!-- en row -->
        </div>
      </div>
      <!-- end card -->
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Data Table</h4>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              id="jobSearchTable"
              :items="filteredTableData"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-compare="tableSort"
              :filter="filter"
              :filter-included-fields="filterOn"
            >
              <template v-slot:cell(goToJob)="data">
                <router-link
                  :to="{ path: '/production/jobs/jobDetails/' + data.item.job }"
                >
                  <b-button
                    :id="`button-${data.index}`"
                    :variant="getButtonVariant(data.item)"
                    v-bind:class="'job' + data.item.job"
                    >Details</b-button
                  >
                  <b-tooltip
                    v-if="
                      data.item.approvedStatus !== null &&
                      (data.item.approvedStatus.times > 0 ||
                        data.item.approvedStatus.products > 0 ||
                        data.item.approvedStatus.files > 0)
                    "
                    :target="`button-${data.index}`"
                    triggers="hover"
                  >
                    <div v-if="data.item.approvedStatus.times > 0">
                      <h5 style="display: inline" class="mr-1">
                        <b-badge variant="success"
                          >{{ data.item.approvedStatus.times }} Time{{
                            data.item.approvedStatus.times === 1 ? '' : 's'
                          }}
                          Not Approved</b-badge
                        >
                      </h5>
                    </div>
                    <div
                      v-if="data.item.approvedStatus.products > 0"
                      class="mt-1"
                    >
                      <h5 style="display: inline" class="mr-1">
                        <b-badge variant="info"
                          >{{ data.item.approvedStatus.products }} Product{{
                            data.item.approvedStatus.products === 1 ? '' : 's'
                          }}
                          Not Approved</b-badge
                        >
                      </h5>
                    </div>
                    <div v-if="data.item.approvedStatus.files > 0" class="mt-1">
                      <h5 style="display: inline" class="mr-1">
                        <b-badge variant="light"
                          >{{ data.item.approvedStatus.files }} File{{
                            data.item.approvedStatus.files === 1 ? '' : 's'
                          }}
                          Not Approved</b-badge
                        >
                      </h5>
                    </div>
                  </b-tooltip>
                </router-link>
              </template>
              <template v-slot:cell(supervisor)="data">
                <p>{{ data.value.name }}</p>
              </template>
              <template v-slot:cell(department)="data">
                <p>{{ data.item.jobDepartment }}</p>
              </template>
              <template v-slot:cell(completed)="data">
                <div>
                  <a
                    class="badge font-size-13 mr-2"
                    :class="data.value ? 'badge-success' : 'badge-danger'"
                  >
                    {{ data.value ? 'completed' : 'incomplete' }}
                  </a>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Switches from 'vue-switches';

import firebase from 'firebase';
import { getCustomers } from '../helper/dbHelpers.js';
import moment from 'moment';

import { tableSort } from '../helper/helpers.js';

export default {
  components: {
    DatePicker,
    Switches,
  },
  data() {
    return {
      name: 'searchJobsComponent',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'job',
      sortDesc: true,
      fields: [
        { key: 'goToJob', label: '', sortable: false },
        { key: 'job', label: 'Job #', sortable: true },
        { key: 'completed', label: 'Completed', sortable: true },
        { key: 'Customer', sortable: true },
        { key: 'jobDepartment', label: 'Department', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'Description', sortable: true, class: 'jobDescription' },
      ],
      customers: [],
      searchCustomer: null,
      searchJobNum: null,
      searchStartDate: null,
      searchEndDate: null,
      tableData: [],
      searchJob_errors: {
        jobNumError: null,
        jobNumMessage: null,
      },
      showCompletedJobs: false,
      showUnapprovedJobsItems: false,
      currentUser: this.$store.state.custom.currentUserData,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.filteredTableData.length;
    },
    filteredTableData(){

      let filteredData = this.tableData
      if(!this.showCompletedJobs){ 
        filteredData = filteredData.filter((o) => !o.completed);
      }

      if(this.showUnapprovedJobsItems){
        filteredData = filteredData.filter(data => data.approvedStatus && (
        data.approvedStatus.times > 0 ||
        data.approvedStatus.products > 0 ||
        data.approvedStatus.files > 0
      ));
      }
      return filteredData
    }
  },
  watch: {
    perPage(newVal, oldVal) {
      this.currentUser = this.$store.state.custom.currentUserData;
      let oldCurrentUserPerPage = null;

      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_jobSearch){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_jobSearch;
          }
          currentUserDataCopy.tablePageLengths['perPage_jobSearch'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_jobSearch: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  methods: {
    searchJobs: function () {
      //construct the query string.
      if (this.validateSearchJob()) {
        try {
          this.tableData = [];
          let query = firebase
            .firestore()
            .collection('jobs')
            .where('org', '==', sessionStorage.getItem('org'));
          if (this.searchJobNum != null && this.searchJobNum != '') {
            query = query.where('jobNum', '==', Number(this.searchJobNum));
          }
          if (this.searchCustomer != null && this.searchCustomer != '') {
            query = query.where(
              'customerDisplayName',
              '==',
              this.searchCustomer
            );
          }

          if (this.searchStartDate != null && this.searchStartDate != '') {
            query = query.where('date', '>=', this.searchStartDate);
          }
          if (this.searchEndDate != null && this.searchEndDate != '') {
            query = query.where(
              'date',
              '<=',
              new Date(moment(this.searchEndDate).endOf('day'))
            );
          }
          //TODO: Order by job num if the query isn't only a job num
          query
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let newJob = {
                  goToJob: `bx-chevron-left`,
                  job: doc.data().jobNum,
                  Customer: doc.data().customerDisplayName,
                  jobDepartment: doc.data().jobDepartment ? doc.data().jobDepartment : null,
                  Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  Description: doc.data().description,
                  approvedStatus: doc.data().approvedStatus
                    ? doc.data().approvedStatus
                    : null,
                  completed: doc.data().completed
                    ? doc.data().completed
                    : false,
                };
                this.tableData.push(newJob);
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } catch (err) {
          console.log(`Error getting job data: ${err}`);
        }
      }
    },
    validateSearchJob: function () {
      let flag = true;
      //Job # is not valid
      if (isNaN(this.searchJobNum)) {
        this.searchJob_errors.jobNumError = true;
        this.searchJob_errors.jobNumMessage = 'Must enter a valid job number.';
        flag = false;
      } else {
        this.searchJob_errors.jobNumError = false;
        this.searchJob_errors.jobNumMessage = null;
      }
      return flag;
    },
    getButtonVariant(data) {
      if (data.approvedStatus === null || data.approvedStatus === undefined) {
        return 'primary';
      } else if (
        data.approvedStatus.times > 0 ||
        data.approvedStatus.products > 0 ||
        data.approvedStatus.files > 0
      ) {
        return 'danger';
      } else {
        return 'primary';
      }
    },
    getInitialCustomers: function () {
      getCustomers()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.customers.push(doc.data().displayName);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_jobSearch) {
          this.perPage = this.currentUser.tablePageLengths.perPage_jobSearch;
        }
      }
    },
    getInitialJobs() {
      firebase
        .firestore()
        .collection('jobs')
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then((querySnapshot) => {
          let supervisorPresent = false;

          querySnapshot.forEach((doc) => {
            let newJob = {
              goToJob: `bx-chevron-left`,
              job: doc.data().jobNum,
              Customer: doc.data().customerDisplayName,
              jobDepartment: doc.data().jobDepartment ? doc.data().jobDepartment : null,
              Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
              Description: doc.data().description,
              supervisor: doc.data().supervisor ? doc.data().supervisor : null,
              approvedStatus: doc.data().approvedStatus
                ? doc.data().approvedStatus
                : null,
              completed: doc.data().completed ? doc.data().completed : false,
            };
            if (doc.data().supervisor) {
              supervisorPresent = true;
            }
            this.tableData.push(newJob);
          });
          if (supervisorPresent) {
            this.fields.push({ key: 'supervisor', sortable: true });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    tableSort: tableSort,
  },
  created: function () {
    this.getInitialCustomers();
    this.getInitialJobs();
    this.setTableSettings();
  },
};
</script>
